import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { IPropertyFilterRequest } from '../../../services/request/property-filter-request.interface';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { SelectModule } from '@openng/optimus-ui/select';
import { PropertyRecommendationService } from '../../../services/property-recommendation.service';
import { ISegments } from '../../../models/property/property-segments.enum';
import { MultiSelectModule } from '@openng/optimus-ui/multiselect';
import { getBrands } from '../../../models/property/property-brands.enum';
import { environment } from '../../../../environments/environment';

import { IProperty, IRecommendedProperty } from '../../../models/property/property.interface';
import { CommonModule } from '@angular/common';
import { ProgressSpinnerModule } from '@openng/optimus-ui/progressspinner';
import { DialogModule } from '@openng/optimus-ui/dialog';
import { TableModule } from '@openng/optimus-ui/table';
import { IRecommendationRequest } from '../../../services/request/recommendation-request.interface';
import { Helper } from '../../../utils/helper';
import { HttpResponse } from '@angular/common/http';
import { ToastBarService } from '../../../services/toast-bar.service';
import { IDestination } from '../../../models/property/property-destinations.enum';
import { Subject, takeUntil } from 'rxjs';
import { ButtonDirective } from '@openng/optimus-ui/button';
import { InputTextModule } from '@openng/optimus-ui/inputtext';
import { TooltipModule } from '@openng/optimus-ui/tooltip';
import { PropertyComponent } from '../property/property.component';
import { MatDialog } from '@angular/material/dialog';
import { PropertyService } from '../../../services/property.service';
import { ISpecialOffer } from '../../../services/special-offer.interface';

@Component({
    selector: 'app-property-recommendation',
    imports: [ReactiveFormsModule, SelectModule, MultiSelectModule, CommonModule, ProgressSpinnerModule, DialogModule, TableModule, FormsModule, ButtonDirective, InputTextModule, TooltipModule],
    templateUrl: './property-recommendation.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./property-recommendation.component.scss']
})
export class PropertyRecommendationComponent implements OnDestroy, OnInit {
  filterForm!: FormGroup;
  loading = false;

  segmentsOptions: { label: string; value: string }[] = [];
  brandsOptions: { label: string; value: string }[] = [];
  starsOptions: { label: string; value: string }[] = [];
  destinationsOptions: { label: string; value: string }[] = [];
  specialOfferOptions: { label: string; value: string }[] = [];

  activityOptions: { label: string; value: boolean }[] = [
    {label: 'Active', value: true},
    {
      label: 'Inactive', value: false
    }];

  selectedLanguages: SelectedLanguages = {
    en: true,
    de: false,
    hr: false,
    it: false,
    cs: false,
    fr: false,
    pl: false,
    si: false,
    sk: false,
  };
  filteredProperties: IProperty[] = [];
  allProperties: IProperty[] = [];
  allRecommendedProperties: IRecommendedProperty[] = [];

  recommendedProperties: IRecommendedProperty[] = [];

  //todo:: napraviti da se dohvaća sa backenda Starts,Brands i Segments ,pa da se pokažu u filterima
  //u tom slučaju će se ovi enumi obrisati
  filteredTableCols: string[] = [];
  recommendedTableCols: string[] = [];

  private _destroy$ = new Subject<void>();

  constructor(
    private fb: FormBuilder,
    private propertyRecommendationService: PropertyRecommendationService,
    private toastBarService: ToastBarService,
    private dialog: MatDialog,
    private propertyService: PropertyService,
  ) {
    ///todo:: dohvatiti sa backenda pa iskoristiti za filter
    this.segmentsOptions = Object.keys(ISegments).map((key) => ({
      label: ISegments[key as keyof typeof ISegments],
      value: key,
    }));

    const brandOptions = getBrands(environment.envName);
///todo:: dohvatiti sa backenda pa iskoristiti za filter

    this.brandsOptions = Object.keys(brandOptions).map(key => ({
      label: brandOptions[key as keyof typeof brandOptions],
      value: brandOptions[key as keyof typeof brandOptions]
    }))
///todo:: dohvatiti sa backenda pa iskoristiti za filter

    this.starsOptions = [
      {label: 'Non rate', value: ''},
      {label: '2*', value: '2*'},
      {label: '3*', value: '3*'},
      {label: '3*/4*', value: '3*/4*'},
      {label: '4*', value: '4*'},
      {label: '4/3*', value: '4/3*'},
      {label: '4*/5*', value: '4*/5*'},
      {label: '4*S', value: '4*S'},
      {label: '5*', value: '5*'},
    ]
///todo:: dohvatiti sa backenda pa iskoristiti za filter
    this.destinationsOptions = Object.keys(IDestination).map((key) => ({
      label: IDestination[key as keyof typeof IDestination],
      value: IDestination[key as keyof typeof IDestination],
    }));
  }

  ngOnInit(): void {
    this.filterForm = this.fb.group({
      stars: [[]],
      brand: [[]],
      segments: [[]],
      destinations: [[]],
      specialOffers: [[]],
      activities: [[true]]
    });
    this.setSpecialOfferOptions()
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  private setSpecialOfferOptions() {
    this.propertyRecommendationService.getSpecialOffersOptions()
      .pipe(takeUntil(this._destroy$))
      .subscribe({

        next: (response: any) => {
          console.log("RESPONSE->", response);
          this.specialOfferOptions = response.map((offer: string[]) => ({
            label: offer,
            value: offer,
          }));
        },
        error: (error: any) => {
          console.error("Error loading offers" + error);
        }
      })
  }

  setFilteredTableColumns() {
    if (this.allProperties && this.allProperties?.length) {
      const first = this.allProperties[0];
      const columns: string[] = [];

      Object.keys(first).forEach(key => {

        if (key === 'destination') {
          // razbij destination na dva pod-polja
          columns.push('destination.name', 'destination.sector');
        } else {
          columns.push(key);
        }
      });

      columns.push('specialOffersMinPrice');

      this.filteredTableCols = columns;
    }
  }


  setRecommendedTableColumns() {
    if (this.allRecommendedProperties && this.allRecommendedProperties?.length) {
      this.recommendedTableCols = [...Object.keys(this.allRecommendedProperties[0]), 'specialOffersMinPrice'];
    }
  }

  getSpecialOffersMinPrice(specialOffers: ISpecialOffer[] | undefined | null): string {
    if (!specialOffers || specialOffers.length === 0) {
      return '';
    }

    const prices = specialOffers
      .filter(offer => offer && offer.minPrice > 0)
      .map(offer => this.formatPrice(offer.minPrice));

    return Array.from(new Set(prices)).join(', ');
  }

  // Cijela cijena bez decimala (npr. "55"), necjelobrojna s decimalnom točkom (npr. "55.99") - usklađeno s Excel exportom.
  formatPrice(value: number | string | null | undefined): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    const numeric = typeof value === 'number' ? value : parseFloat(String(value).replace(',', '.'));
    if (isNaN(numeric)) {
      return String(value);
    }

    return numeric.toFixed(2).replace(/\.?0+$/, '');
  }

  generateSubset() {
    this.loading = true;
    const filter: IPropertyFilterRequest = this.filterForm.value;
    console.log("filter", filter);
    this.propertyRecommendationService
      .createSubset(filter)
      .pipe(takeUntil(this._destroy$))
      .subscribe({
        next: (response: any) => {
          console.log("properties response", response);
          this.allProperties = response;
          if (this.allProperties?.length == 0) {
            this.toastBarService.showToast({
              severity: 'info',
              summary: 'Info',
              detail: `Nema rezultata za ove filtere`,
            });
          }
          this.setFilteredPropsBySelectedLang();
          this.setFilteredTableColumns();

          if (this.recommendedProperties?.length > 0) {
            this.recommendedProperties = [];
            this.allRecommendedProperties = [];
          }

          this.loading = false;
        },
        error: (error: any) => {
          console.error(error);
          this.loading = false;
        },
      });
  }

  generateRecommendation() {
    this.loading = true;

    // Hu jezik još nije podržan u recommendation flowu - ne šaljemo ga dok se ne implementira.
    const supportedProperties = this.allProperties.filter(prop => prop.languageId?.toLowerCase() !== 'hu');

    const skippedProperties = supportedProperties.filter(prop => this.isInvalidProperty(prop));
    const validProperties = supportedProperties.filter(prop => !this.isInvalidProperty(prop));
    if (skippedProperties.length > 0) {
      const details = skippedProperties
        .map(prop => `${prop.name} (${prop.languageId.toUpperCase()})`)
        .join(', ');
      this.toastBarService.showToast({
        severity: 'warn',
        summary: 'Warn',
        detail: `Preskočeno ${skippedProperties.length} property-a bez naziva destinacije: ${details}`,
      });
    }

    const recommendationRequest: IRecommendationRequest = {
      FilteredProperties: validProperties,
    };
    this.propertyRecommendationService
      .createRecommendation(recommendationRequest)
      .pipe(takeUntil(this._destroy$))
      .subscribe({
        next: (response: any) => {
          this.allRecommendedProperties = response.result;
          if (this.allRecommendedProperties?.length > 0) {
            // Set selected languages to de and hr after generate recommendation
            this.selectedLanguages = {
              en: true,
              hr: true,
              de: true,
              it: true,
              si: true,
              cs: false,
              fr: false,
              pl: false,
              sk: false,
            };
            this.setRecommendedTableColumns();
            this.setRecommendedPropsBySelectedLang();
          } else {
            //msg
            this.toastBarService.showToast({
              severity: 'warn',
              summary: 'Warn',
              detail: `There is no recommendations for this subset`,
            });
          }

          this.loading = false;
        },
        error: (error: any) => {
          console.error(error);
          this.toastBarService.showToast({
            severity: 'error',
            summary: 'Error',
            detail: `${error.message}`,
          });
          this.loading = false;
        },
      });
  }

  exportExcel() {
    this.loading = true;
    this.propertyRecommendationService
      .exportExcel(this.recommendedProperties)
      .pipe(takeUntil(this._destroy$))
      .subscribe({
        next: (res: HttpResponse<Blob>) => {
          console.log('Excel res-> ', res);
          let contentDisposition = res.headers.get('content-disposition');
          let filename = `Preporuka.xlsx`;

          if (contentDisposition) {
            // prvo pokušaj iz filename*=
            let matchesStar = /filename\*\s*=\s*UTF-8''([^;\n]+)/i.exec(
              contentDisposition
            );
            if (matchesStar && matchesStar[1]) {
              filename = decodeURIComponent(matchesStar[1]);
            } else {
              // ako nema, koristi filename=
              let matches = /filename\s*=\s*([^;\n]+)/i.exec(
                contentDisposition
              );
              if (matches && matches[1]) {
                filename = matches[1].trim();
                // makni eventualne navodnike
                filename = filename.replace(/^["']|["']$/g, '');
              }
            }
          }

          const blob = res.body!;
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
          this.loading = false;
        },
        error: (error: any) => {
          console.error(error);
          this.loading = false;
        },
      });
  }

  languageKeys(): (keyof SelectedLanguages)[] {
    return Object.keys(this.selectedLanguages) as (keyof SelectedLanguages)[];
  }

  onLanguageToggle(lang: string, event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    this.selectedLanguages[lang as keyof SelectedLanguages] = checked;
    this.setFilteredPropsBySelectedLang();
    if (this.allRecommendedProperties?.length > 0) {
      this.setRecommendedPropsBySelectedLang();
    }
  }

  setFilteredPropsBySelectedLang() {
    if (this.allProperties?.length == 0) {
      this.filteredProperties = [];
      return;
    }
    this.filteredProperties = this.allProperties.filter(
      (prop) =>
        this.selectedLanguages[prop.languageId as keyof SelectedLanguages]
    );

    if (this.filteredProperties?.length == 0) {
      //todo:: stavljeno kako bi spriječilo da odselektaju sve checkboxe.
      //ako netko dočekira sve ,vratiti će mu se selected all
      Object.entries(this.selectedLanguages).forEach(
        ([langCode, isChecked]) => {
          this.selectedLanguages[langCode as keyof SelectedLanguages] = true;
        }
      );
      this.filteredProperties = this.allProperties;
    }
  }

  setRecommendedPropsBySelectedLang() {
    this.recommendedProperties = this.allRecommendedProperties.filter(
      (prop) =>
        this.selectedLanguages[prop.languageId as keyof SelectedLanguages]
    );
    if (this.recommendedProperties?.length == 0) {
      //todo:: stavljeno kako bi spriječilo da odselektaju sve checkboxe.
      //ako netko dočekira sve ,vratiti će mu se selected all
      Object.entries(this.selectedLanguages).forEach(
        ([langCode, isChecked]) => {
          this.selectedLanguages[langCode as keyof SelectedLanguages] = true;
        }
      );
      this.recommendedProperties = this.allRecommendedProperties;
    }
  }

  isInvalidProperty(property: IProperty): boolean {
    return !property?.destination?.name;
  }

  removeProperty(property: IProperty) {
    var filteredProperties = this.filteredProperties.filter(prop => prop.crmPropertyId != property.crmPropertyId)
    this.filteredProperties = filteredProperties;
    this.allProperties = filteredProperties;
  }

  onRecommendedInputChange(rowIndex: any, col: string, value?: string) {

    const prop = this.allProperties.find(prop => prop.crmPropertyId == value?.trim());

    const recProp = this.recommendedProperties[rowIndex];
    if (prop) {
      if (col === 'recommended1') {
        recProp.recommended1 = prop.crmPropertyId;
        recProp.recommended1Name = prop.name;
      } else if (col === 'recommended2') {
        recProp.recommended2 = prop.crmPropertyId;
        recProp.recommended2Name = prop.name;
      } else if (col === 'recommended3') {
        recProp.recommended3 = prop.crmPropertyId;
        recProp.recommended3Name = prop.name;
      }
    } else {
      // Ako property nije pronađen, poništi vrijednosti
      if (col === 'recommended1') {
        recProp.recommended1 = "";
        recProp.recommended1Name = "";
      } else if (col === 'recommended2') {
        recProp.recommended2 = "";
        recProp.recommended2Name = "";
      } else if (col === 'recommended3') {
        recProp.recommended3 = "";
        recProp.recommended3Name = "";
      }
    }
  }


  editProperty(property: IProperty): void {
    this.loading = true;
    this.propertyService.getProperty(property.crmPropertyId)
      .pipe(takeUntil(this._destroy$))
      .subscribe({
        next: (response: any) => {
          this.loading = false;
          const dialogRef = this.dialog.open(PropertyComponent, {
            // height: '600px',
            //width: '66.67vw',
            minWidth: '40vw',
            data: response
          });

          dialogRef.afterClosed().subscribe((result: IProperty) => {
            if (result) {
              this.generateSubset();
            }
          });
        },
        error: (error: any) => {
          console.error("Error fetching property" + error);
          this.toastBarService.showToast({
            severity: 'error',
            summary: 'Error',
            detail: `${error.message}`,
          });
          this.loading = false;
        }
      })
  }


  protected readonly Helper = Helper;
  protected readonly length = length;
}

type LanguageCode =
  | 'en'
  | 'de'
  | 'hr'
  | 'it'
  | 'cs'
  | 'fr'
  | 'pl'
  | 'si'
  | 'sk';
type SelectedLanguages = Record<LanguageCode, boolean>;
